import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoriesSection from "./components/CategoriesSection";
import FeaturedProducts from "./components/FeaturedProducts";
import HowItWorks from "./components/HowItWorks";
import Testimonials from "./components/Testimonials";

const HomePage = () => {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoriesSection />
        <FeaturedProducts limit={6} showViewAll />
        <HowItWorks />
        <Testimonials />
      </main>
      <Footer />
    </>
  );
};

export default HomePage;
